
import {
  FormWithRedirect,
  TextInput,
  SaveButton,
  TextField,
} from 'react-admin';
import { Box, Toolbar } from '@material-ui/core';
import AddressMap from "./map/address-map";
import { useEffect, useState } from 'react';
import { useGoogleAddressParser, mergeRecords } from '../../utils/helpers';
import isEmpty from 'lodash.isempty';
import { Alert } from '@mui/material';


export const CustomEditForm = (props: any): JSX.Element => {
  const [autoComplete, setAutoComplete] = useState<google.maps.places.PlaceResult>({});
  const [records, setRecords] = useState({
    oldRecord: {...props.record},
    newRecord:{}
  });
  const latitude = autoComplete.geometry?.location?.lat();
  const longitude = autoComplete.geometry?.location?.lng();
  const {addressComponents} = useGoogleAddressParser(autoComplete.address_components);
  const address = `${addressComponents.street_number} ${addressComponents.route}`;
  const fullAddress = autoComplete.formatted_address;
  const google_place_id = autoComplete.place_id;
  useEffect(() => {
    const newRecord = {latitude, longitude, ...addressComponents,
      google_place_id, address, user_id: props?.record?.user_id ?? props?.location?.state?.id};

    if(!isEmpty(autoComplete)) {
      setRecords({
        oldRecord: {...props.record},
        newRecord
      })
      mergeRecords(props.record, newRecord);
    }
    
  }, [autoComplete])
  
  return (
    <FormWithRedirect
      {...props}
      render={formProps => {        
        return (
          <form>
            <Box display="flex" p="1em">
              <Box flex={0.6} flexDirection="column" style={{padding: '0 40px 0 20px'}}>
                <TextField source="id" label="Id" resource="addresses" />
                <TextInput source="apt" resource="addresses" type="text"
                  label="Apt" style={{display:"flex", minWidth: '200px', maxWidth: '350px'}} variant="outlined"
                />
                <TextInput source="delivery_note" resource="addresses"
                  type="text" multiline label="Delivery Note" style={{display:"flex", minWidth: '200px', maxWidth: '350px'}} variant="outlined" 
                />
                {!isEmpty(autoComplete) && 
                <Alert variant="filled" severity="info">
                  {`To ${props.create ? 'create' : 'update to'} this address:`}
                  <br/>
                  {fullAddress}
                  <br/>
                  press SAVE
                </Alert>}                
              </Box>
              <Box flex={1}  sx={{
                width: '100%',
                height: '50vh',
              }}>                       
                <AddressMap setAutoComplete={setAutoComplete} records={records} showAutoComplete/>
              </Box>
            </Box>
            <Toolbar>
              <Box display="flex" justifyContent="space-between" width="100%">
                <SaveButton
                  saving={formProps.saving}
                  handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                />
              </Box>
            </Toolbar>
          </form>
        )}}
    />
  )};
